export default {
  ru: {
    title: 'Сервисное меню',
    backToMenu: 'Назад в меню',
    tryAgain: 'Попробовать еще',
    operationComplete: 'Операция успешно завершена',
    goHome: 'На главную',
    enter: 'Войти',
    wrongPassword: 'Неверный пароль',
    paperOut: 'Закончилась бумага',
    openSession: 'Открыть смену',
    closeSession: 'Закрыть смену',
  },
  en: {
    // en
  },
};
